import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Transport } from '@/models/Transport'

export default new CachedResourceStore<Transport>(Transport, {
	namespaced: true
})
